import { Outlet, createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/app/orchestra")({
  component: Outlet,
  beforeLoad: (context) => {
    return {
      getTitle: () => context?.context.t && context.context.t("Orchestra"),
    }
  },
})
